import React from 'react';
import Office365AltLogoSrc from './Office365AltLogo.png';

function Office365AltLogo({ ...props }) {
  return <img src={Office365AltLogoSrc} alt="Office365AltLogo.png" {...props} />;
}

export default Office365AltLogo;
